export default {
  survey: (state) => state.survey,
  surveyDetails: (state) => state.surveyDetails,
  surveys: (state) => state.surveys,
  surveyTypes: (state) => state.surveyTypes,
  incompleteSurveysCount: (state) => state.incompleteSurveysCount,
  surveySections: (state) => {
    // Resource: https://goo.gl/gUuY5P (Remove duplicates from an array of objects in javascript)
    if (typeof state.survey.length === 'undefined') return null
    return state.survey.filter(
      (thing, index, self) =>
        self.findIndex((t) => {
          return t.section.id === thing.section.id && t.section.text === thing.section.text
        }) === index
    )
  },
  incompletedSections: (state) => {
    if (typeof state.survey.length === 'undefined') return null
    let sections = []
    state.survey.filter((item) => {
      if (item.answer.id === null) {
        if (sections.indexOf(item.section.id) === -1) {
          sections.push(item.section.id)
        }
      }
    })
    return sections
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/survey/getters.js